import React from 'react';
import appInfo from './app-info';
import routes from './app-routes';
import { Switch, Route, Redirect } from 'react-router-dom';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import { useAuth } from './contexts/auth';


function setHomePage(user, target) {    
    var response;

    if (user.userType === 4) {
        response = '/richiesteCallCenter';
    }
    else {
        if (target == null) { 
            if(user.checkMandatoryFields) {
                response = '/profile'; 
            } else {
                response = '/home'; 
            }
        }
        else { response = '/flussoApprovativo'; }
    }

    return response;
}

export default function AppContent() {

    const queryParameters = new URLSearchParams(window.location.search);
    const username = queryParameters.get("a");
    const pwd = queryParameters.get("b");
    const target = queryParameters.get("c");

    const { user } = useAuth();

    return (
        <SideNavBarLayout title={`${appInfo.title} v.3.10 -  ${appInfo.company}`} >
            <Switch>
                {routes.map(({ path, component }) => (
                    <Route
                        exact
                        key={path}
                        path={path}
                        component={component}
                    />
                ))}
                <Redirect to={setHomePage(user, target)} />
            </Switch>
            <Footer>
                Copyright © 2011-{new Date().getFullYear()} {appInfo.title} Inc.
            </Footer>
        </SideNavBarLayout>
    );
}